import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000/";

const HrKpiManagement = () => {
  const [kpiList, setKpiList] = useState([]);
  const [kraList, setKraList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showKpiFilters, showKpiFilter] = useState(true);
  const [kpiOptionList, setKpiOptionList] = useState([]);
  const [userRole, setUserole] = useState([]);
  const [department, setDepdata] = useState([]);
  const [showKpiForm, setShowKpiForm] = useState(false);

  const [editingKpi, setEditingKpi] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);

  const token = JSON.parse(localStorage.getItem("key"));

  const [filters, setFilters] = useState({
    financial_year: "",
    kra_id: "",
    status: "",
  });
  const [kpiForm, setKpiForm] = useState({
    kra_id: "",
    // kpi_code: "",
    // dept_id: "",
    role_id: "",
    kpi_name: "",
    description: "",
    // measurement_type: "Percentage",
    target_value: "",
    unit: "%",
    weightage: "",
    frequency: "Quarterly",
  });

  useEffect(() => {
    loadKpi();
    loadKra();
    getDepartmentList();
    getUserRole();
  }, [currentPage, recordsPerPage, filters.financial_year, filters.kra_id]);

  useEffect(() => {
    if (!kpiForm.role_id) {
      getKipList([]);
      return;
    }
    getKipList();
  }, [kpiForm.role_id]);
  const getUserRole = () => {
    const response = fetch(API + `api/common/sytem-role`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUserole(data.result);
      });
  };
  const getDepartmentList = () => {
    const response = fetch(API + `api/common/department_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setDepdata(data?.result);
      });
  };
  const getKipList = () => {
    const queryParams = new URLSearchParams({
      // deptId: kpiForm.dept_id,
      roleId: kpiForm.role_id,
    });
    const response = fetch(
      API + `api/Performance/kpi/optionList?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          //console.log(data, "dddddddddddddd");
          setKpiOptionList(data.data);
        }
      });
  };
  const loadKpi = async () => {
    try {
      const params = new URLSearchParams();

      // Pagination
      params.append("kra", filters.kra_id);
      params.append("financial_year", filters.financial_year);
      params.append("page", currentPage);
      params.append("pageSize", recordsPerPage);
      const res = await axios.get(
        `${API}api/Performance/kpi/all?${params.toString()}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.value}`,
          },
        },
      );

      if (res.data.success) {
        setKpiList(res.data.data);
        setTotalRecords(Number(res.data.total || 0));
      }
    } catch (error) {
      console.error(error);
    }
  };
  const loadKra = async () => {
    try {
      const res = await axios.get(`${API}api/Performance/kra/kraList`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.value}`,
        },
      });
      console.log(res.data, "kRA LIS===========");
      if (res.data.success) {
        setKraList(res.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleKpiChange = (e) => {
    const { name, value } = e.target;

    if (name === "kra_id") {
      const selectedKra = kraList.find(
        (kra) => String(kra.id) === String(value),
      );

      setKpiForm((prev) => ({
        ...prev,
        kra_id: value,
        weightage: selectedKra ? selectedKra.weightage : "",
      }));

      return;
    }

    setKpiForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const clearFilters = () => {
    setFilters({
      financial_year: "",
      kra_id: "",
      status: "",
    });

    setCurrentPage(1);
  };
  const submitKpi = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.value}`,
        },
      };

      const data = {
        kpiForm: kpiForm,
      };
      if (editingKpi) {
        await axios.put(
          `${API}api/Performance/kpi/${editingKpi.id}`,
          data,
          config,
        );

        alert("KPI updated successfully");
        setLoading(false);
      } else {
        await axios.post(`${API}api/Performance/kpi`, data, config);

        alert("KPI created successfully");
        setLoading(false);
      }

      resetKpi();

      loadKpi();
    } catch (error) {
      console.error(error);

      alert(error.response?.data?.message || "Unable to save KPI");
      setLoading(false);
    }
  };

  const resetKpi = () => {
    setKpiForm({
      kra_id: "",
      // kpi_code: "",
      // dept_id: "",
      role_id: "",
      kpi_name: "",
      description: "",
      // measurement_type: "Percentage",
      target_value: "",
      unit: "%",
      weightage: "",
      frequency: "Quarterly",
    });

    setEditingKpi(null);
    setShowKpiForm(false);
    showKpiFilter(true);
    setCurrentPage(1);
  };

  const editKpi = (item) => {
    setEditingKpi(item);
    // console.log(item, "item edit=================");
    setKpiForm({
      kra_id: item.kra_id,
      // kpi_code: item.kpi_code,
      // dept_id: item.dept_id,
      role_id: item.role_id,
      kpi_name: item.kpi_name,
      description: item.description || "",
      // measurement_type: item.measurement_type,
      target_value: item.target_value || "",
      unit: item.unit || "",
      weightage: item.weightage,
      frequency: item.frequency,
    });

    setShowKpiForm(true);
    showKpiFilter(false);
    setTimeout(() => {
      document.getElementById("content_area")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
    //setCurrentPage(1);
  };

  const deleteKpi = async (id) => {
    if (!window.confirm("Delete this KPI?")) {
      return;
    }

    try {
      await axios.delete(`${API}api/Performance/kpi/${id}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.value}`,
        },
      });

      loadKpi();
      showKpiFilter(true);
      setCurrentPage(1);
    } catch (error) {
      console.error(error);
    }
  };
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const startIndex =
    totalRecords === 0 ? 0 : (currentPage - 1) * recordsPerPage;

  const endIndex = Math.min(currentPage * recordsPerPage, totalRecords);
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      setCurrentPage(page);
    }
  };
  const getPageNumbers = () => {
    const pages = [];

    // No pages
    if (totalPages <= 0) {
      return pages;
    }

    // 1 - 5 pages
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // Current page near beginning
    if (currentPage <= 3) {
      pages.push(1, 2, 3, 4, "...", totalPages);

      return pages;
    }

    // Current page near end
    if (currentPage >= totalPages - 2) {
      pages.push(
        1,
        "...",
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      );

      return pages;
    }

    // Current page in middle
    pages.push(
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages,
    );

    return pages;
  };
  const truncateWords = (text, limit = 5) => {
    if (!text) return "";

    const words = text.trim().split(/\s+/);

    if (words.length <= limit) {
      return text;
    }

    return words.slice(0, limit).join(" ") + "...";
  };

  return (
    <>
      <div className="page-header">
        <h1>
          KPI Management
          <button
            type="button"
            className="btn btn-sm btn-info mr08 float-end"
            onClick={() => {
              resetKpi();
              setShowKpiForm(true);
              showKpiFilter(false);
            }}
          >
            + Add KPI
          </button>
        </h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li>
            <Link to="/employeelist">
              <span>/</span>KPI Management{" "}
            </Link>
          </li>
          <li className="current">
            <span>/</span>Master
          </li>
        </ul>
      </div>
      {showKpiForm && (
        <div className="row_bg" id="kpi-form">
          <div className="dash_white_box2 mb20 p20">
            <strong>{editingKpi ? "Edit KPI" : "Add KPI"}</strong>
            <div className="row mb30">
              <form onSubmit={submitKpi}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label>Role</label>
                      <select
                        className="form-select"
                        name="role_id"
                        value={kpiForm.role_id}
                        onChange={handleKpiChange}
                        required
                      >
                        <option value="">Select Role</option>
                        {userRole?.map((item, ind) => (
                          <option key={ind} value={item.id}>
                            {item.role}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>KRA</label>

                      <select
                        className="form-select"
                        name="kra_id"
                        value={kpiForm.kra_id}
                        onChange={handleKpiChange}
                        required
                      >
                        <option value="">Select KRA</option>

                        {kpiOptionList.map((kra) => (
                          <option key={kra.id} value={kra.id}>
                            {kra.kra_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>KPI Name</label>

                      <input
                        type="text"
                        className="form-control"
                        name="kpi_name"
                        value={kpiForm.kpi_name}
                        onChange={handleKpiChange}
                        placeholder="Task Completion"
                        required
                      />
                    </div>

                    {/* <div className="col-md-4 mb-3">
                      <label>Measurement Type</label>

                      <select
                        className="form-select"
                        name="measurement_type"
                        value={kpiForm.measurement_type}
                        onChange={handleKpiChange}
                      >
                        <option value="Percentage">Percentage</option>

                        <option value="Number">Number</option>

                        <option value="Amount">Amount</option>

                        <option value="Rating">Rating</option>

                        <option value="Boolean">Yes / No</option>

                        <option value="Text">Text</option>
                      </select>
                    </div>
                      */}
                    <div className="col-md-4 mb-3">
                      <label>Target</label>

                      <input
                        type="number"
                        className="form-control"
                        name="target_value"
                        value={kpiForm.target_value}
                        onChange={handleKpiChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Unit Value</label>
                      <select
                        className="form-select"
                        name="unit"
                        value={kpiForm.unit}
                        onChange={handleKpiChange}
                      >
                        <option value="">Select</option>
                        <option value="Percentage">Percentage %</option>
                        <option value="In Point">In Point</option>
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Weightage %</label>

                      <input
                        type="number"
                        min="0"
                        max="100"
                        className="form-control"
                        name="weightage"
                        value={kpiForm.weightage}
                        onChange={handleKpiChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Frequency</label>

                      <select
                        className="form-select"
                        name="frequency"
                        value={kpiForm.frequency}
                        onChange={handleKpiChange}
                      >
                        <option value="Quarterly">Quarterly</option>

                        <option value="Yearly">Yearly</option>
                      </select>
                    </div>

                    <div className="col-md-8 mb-3">
                      <label>Description</label>

                      <textarea
                        className="form-control"
                        rows="2"
                        name="description"
                        value={kpiForm.description}
                        onChange={handleKpiChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <button
                    type="submit"
                    className="btn btn-sm btn-success mr08 float-end"
                  >
                    Save KPI
                  </button>

                  <button
                    type="button"
                    className="btn btn-sm btn-danger mr08 float-end"
                    onClick={resetKpi}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      <div className="row_bg">
        {showKpiFilters && (
          <div className="dash_white_box2 mb10 p10">
            <label className="form-label">Search</label>
            <div className="row mb10">
              <div className="col-lg-3 col-md-6 pl07 pr07">
                <label className="form-label">Financial Year</label>
                <select
                  className="form-control"
                  value={filters.financial_year}
                  name="financial_year"
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      financial_year: e.target.value,
                    })
                  }
                >
                  <option value="">Select</option>
                  <option value="2025-26">2025-26</option>

                  <option value="2026-27">2026-27</option>

                  <option value="2027-28">2027-28</option>
                </select>
              </div>
              <div className="col-lg-3 col-md-6 pl07 pr07">
                <label className="form-label">KRA</label>
                <select
                  className="form-control"
                  value={filters.kra_id}
                  name="kra_id"
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      kra_id: e.target.value,
                    })
                  }
                >
                  <option value="">Select</option>
                  {kraList?.map((item, ind) => (
                    <option key={ind} value={item.id}>
                      {item.kra_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-lg-3 col-md-6 pl07 pr07">
                <label className="d-block mb30 pt07"></label>
                <button className="btn_6" onClick={clearFilters}>
                  Clear Filters
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="dash_white_box2">
          <strong>KPI Master</strong>
          <div className="row mb30">
            <div className="col-md-12">
              <div className="table-responsive">
                <table
                  className="table_style_1 table-bordered table-hover mb-0"
                  style={{
                    minWidth: "1200px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Financial Year</th>
                      <th>KRA</th>
                      {/* <th>KPI Code</th> */}
                      <th>KPI</th>
                      {/* <th>Measurement</th> */}
                      <th>Target</th>
                      <th>Unit Value</th>
                      <th>Weightage</th>
                      <th>Frequency</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {kpiList.length === 0 ? (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No KPI found
                        </td>
                      </tr>
                    ) : (
                      kpiList.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>

                          <td>{item.financial_year}</td>

                          <td>
                            <strong>{item.kra_code}</strong>
                            <br />
                            <small>{item.kra_name}</small>
                          </td>

                          {/* <td>{item.kpi_code}</td> */}

                          <td>
                            <span
                              style={{ cursor: "pointer" }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title={
                                item.kpi_name?.trim().split(/\s+/).length > 5
                                  ? item.kpi_name
                                  : ""
                              }
                            >
                              {truncateWords(item.kpi_name, 5)}
                            </span>
                          </td>

                          {/* <td>{item.measurement_type}</td> */}

                          <td>{item.target_value}</td>
                          <td>
                            {item.unit === "Percentage"
                              ? `%`
                              : item.unit === "In Point"
                                ? `In Point`
                                : ""}
                          </td>

                          <td>{item.weightage}%</td>

                          <td>{item.frequency}</td>

                          <td>
                            <button
                              className="btn_3 btn-sm btn-warning me-1"
                              onClick={() => editKpi(item)}
                            >
                              Edit
                            </button>

                            <button
                              className="btn_2 btn-sm btn-danger"
                              onClick={() => deleteKpi(item.id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              {/* =================================================
              PAGINATION
              ================================================= */}

              {totalRecords > 0 && (
                <div className="pagination-wrapper">
                  {/* Pagination Info */}
                  <div className="pagination-info">
                    Showing <strong>{startIndex + 1}</strong> to{" "}
                    <strong>{endIndex}</strong> of{" "}
                    <strong>{totalRecords}</strong> entries
                  </div>

                  {/* Pagination */}
                  <div className="pagination">
                    {/* Previous */}
                    <button
                      disabled={currentPage === 1 || loading}
                      onClick={() => goToPage(currentPage - 1)}
                    >
                      <i className="bi bi-chevron-left">«</i>
                    </button>

                    {/* Page Numbers */}
                    {getPageNumbers().map((page, index) => {
                      if (page === "...") {
                        return (
                          <span
                            key={`dots-${index}`}
                            className="pagination-dots"
                          >
                            ...
                          </span>
                        );
                      }

                      return (
                        <button
                          key={page}
                          disabled={loading}
                          className={currentPage === page ? "active" : ""}
                          onClick={() => goToPage(page)}
                        >
                          {page}
                        </button>
                      );
                    })}

                    {/* Next */}
                    <button
                      disabled={currentPage === totalPages || loading}
                      onClick={() => goToPage(currentPage + 1)}
                    >
                      <i className="bi bi-chevron-right">»</i>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HrKpiManagement;
